import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { type EdgeAutoScrollConfig } from './edge-auto-scroller';

export interface DragSelectionScrollOffset {
  scrollTop: number;
  scrollLeft: number;
}

export interface DragSelectionHost {
  getViewport(): HTMLElement | null;
  getContent(): HTMLElement | null;
  getScrollOffset$(): Observable<DragSelectionScrollOffset>;
  getEdgeAutoScrollConfig?(): EdgeAutoScrollConfig;
}

export const DRAG_SELECTION_HOST = new InjectionToken<DragSelectionHost>('DRAG_SELECTION_HOST');
